import { Avatar, Card, CardHeader, Skeleton } from "@mui/material";
import React from "react";

export default function UserCard({ user, action = null }) {

  if(!user) return null;
  
  return (
    <Card>
      <CardHeader
        avatar={<Avatar alt={user.username} src={user.avatarUrl} />}
        title={user.username}
        action={action}
      />
    </Card>
  );
}
